export default __webpack_public_path__ + "static/media/blue-dots-bottom-right.2b0c156e.svg";